import React from 'react';
import cn from 'classnames';
import { S2FontFamily } from 'apps/sigma2-ui/src/components/utils/tailwind-overrides';
import { safeTwClass } from 'apps/sigma2-ui/src/components/utils/tailwind-overrides';
import { TextColor } from 'apps/sigma2-ui/src/components/utils/tailwind-overrides';
import { TextSize } from 'apps/sigma2-ui/src/components/utils/tailwind-overrides';

/**
 * @deprecated Use the `Typography` component instead.
 * @see Typography
 */
export const Paragraph: React.FC<{
  children: React.ReactNode;
  className?: string;
  textColor?: TextColor;
  fontFamily?: S2FontFamily;
  textSize?: TextSize;
}> = ({ children, className, textColor, fontFamily, textSize }) => {
  return (
    <p
      className={cn(
        safeTwClass<TextColor>({
          defaultValue: TextColor.Values['text-gray-800'],
          override: textColor,
        }),
        safeTwClass<S2FontFamily>({
          defaultValue: S2FontFamily.Values['font-sans'],
          override: fontFamily,
        }),
        safeTwClass<TextSize>({
          defaultValue: TextSize.Values['text-sm'],
          override: textSize,
        }),
        className,
      )}
    >
      {children}
    </p>
  );
};
